import AnalysisAndCommunication from "./AnalysisAndCommunication";
export default AnalysisAndCommunication;
